module.exports = __webpack_public_path__ + "img/sankaku_36_red.eb3c8eca.png";